import { render, staticRenderFns } from "./ComparisonInfo.vue?vue&type=template&id=c72428d2&scoped=true&"
import script from "./ComparisonInfo.vue?vue&type=script&lang=js&"
export * from "./ComparisonInfo.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonInfo.vue?vue&type=style&index=0&id=c72428d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72428d2",
  null
  
)

export default component.exports